import { render, staticRenderFns } from "./r-text.vue?vue&type=template&id=1190938a&scoped=true"
import script from "./r-text.vue?vue&type=script&lang=js"
export * from "./r-text.vue?vue&type=script&lang=js"
import style0 from "./r-text.vue?vue&type=style&index=0&id=1190938a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190938a",
  null
  
)

export default component.exports